(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video-facade"] && !Shopify.designMode) return;
  try {
    (function() {
    const videoFacades = document.querySelectorAll('.video-facade[data-video-id]');

    videoFacades.forEach(function(videoFacade) {
      const facade = videoFacade.querySelector('.video-facade__facade');
      const playButton = videoFacade.querySelector('.video-facade__play-button');
      const player = videoFacade.querySelector('.video-facade__player');

      if (!facade || !playButton || !player) {
        return;
      }

      const mode = facade.getAttribute('data-video-mode') || 'native';
      const video = videoFacade.querySelector('.video-facade__video');

      if (mode === 'native' && !video) {
        return;
      }

      function loadVideo() {
        if (facade.dataset.videoLoaded === 'true') {
          return;
        }

        facade.dataset.videoLoaded = 'true';
        facade.style.display = 'none';
        player.hidden = false;
        player.style.display = 'block';

        if (mode === 'external') {
          const embedSrc = facade.getAttribute('data-embed-src');
          const iframeTitle = facade.getAttribute('data-iframe-title') || '';
          if (!embedSrc) {
            return;
          }
          const iframe = document.createElement('iframe');
          iframe.src = embedSrc;
          iframe.setAttribute('allow', 'autoplay; fullscreen');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('title', iframeTitle);
          iframe.className = 'video-facade__iframe';
          player.appendChild(iframe);
          iframe.focus();
          return;
        }

        video.focus();
        video.load();

        const tryPlay = function() {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise
              .then(function() {})
              .catch(function() {
                video.controls = true;
              });
          }
        };

        if (video.readyState >= 2) {
          tryPlay();
        } else {
          video.addEventListener(
            'canplay',
            function() {
              tryPlay();
            },
            { once: true }
          );

          setTimeout(function() {
            if (video.paused) {
              tryPlay();
            }
          }, 1000);
        }
      }

      playButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        loadVideo();
      });

      playButton.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          loadVideo();
        }
      });

      facade.addEventListener('click', function(event) {
        if (event.target !== playButton && !playButton.contains(event.target)) {
          event.preventDefault();
          event.stopPropagation();
          loadVideo();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
